import { ManagedDepartment } from "models/dbModels/managedDepartments/ManagedDepartment";
import { ManagedManufacturer } from "models/dbModels/managedManufacturers/ManagedManufacturer";
import { ManagedStockGroup } from "models/dbModels/managedStockGroups/ManagedStockGroup";
import { ManagedSubdepartment } from "models/dbModels/managedSubdepartments/ManagedSubdepartment";
import { ManagedSupplier } from "models/dbModels/managedSuppliers/ManagedSupplier";

export const DepartmentNotSet: ManagedDepartment = {
    id: -1,
    name: "Not Set",
    number: "",
    lock: false,
    modelId: ""
};

export const SubDepartmentNotSet: ManagedSubdepartment = {
    id: -1,
    departmentId: -1,
    name: "Not Set",
    number: "",
    locked: false,
    modelId: ""
}

export const ManufacturerNotSet: ManagedManufacturer = {
    id: -1,
    name: "Not Set",
    locked: false,
    code: "",
    modelId: ""
}

export const SupplierNotSet: ManagedSupplier = {
    id: -1,
    name: "Not Set",
    isSystem: false,
    active: false,
    contactName: null,
    address: null,
    suburb: null,
    state: null,
    postcode: null,
    phoneNumber: null,
    faxNumber: null,
    lock: false,
    modelId: "",
    systemCode: null
}

export const StockGroupNotSet: ManagedStockGroup = {
    id: -1,
    name: "Not Set",
    locked: false,
    modelId: ""
}